import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { set, get } from '../../../reducers/data'
import "./BeneficiComponent.css"
import clima from "../../../icons/benefici/ben_clima.svg"
import all from "../../../icons/benefici/ben_all.svg"
import frigo from "../../../icons/benefici/ben_frigo.svg"
import foto from "../../../icons/benefici/ben_foto.svg"
import fotov from "../../../icons/benefici/ben_fotov.svg"
import shield from "../../../icons/benefici/shield.svg"
import build from "../../../icons/benefici/build.svg"
import food from "../../../icons/benefici/food.svg"
import lock from "../../../icons/benefici/lock.svg"
import fire from "../../../icons/benefici/fire.svg"
import campaign from "../../../icons/benefici/campaign.svg"
import plug from "../../../icons/benefici/plug.svg"
import bolt from "../../../icons/benefici/bolt.svg"
import hearth from "../../../icons/benefici/hearth.svg"
import cash from "../../../icons/benefici/cash.svg"
import BlueBoxComponent from '../reusable/BlueBoxComponent'
import BeneficiFinaliComponent from './BeneficiFinaliDesktopComponent'
import { Col } from 'react-bootstrap'



function BeneficiTitleComponent({ title, description }) {
    return (
        <div className="benefici-title mt-4">
            <h2 className="gen-title">{title}</h2>
            {/* <span className="gen-subtitle"></span> */}
            <p className="gen-subtitle">{description}</p>
        </div>
    )
}

const images = {
    "Elettrodomestici": frigo,
    "Riscaldamento": clima,
    "Clima": clima,
    "Fotovoltaico": foto,
    "Offerta luce": fotov,
    "Sintesi investimento": all,
    "Induzione": food,
    "Green": {
        bolt,
        plug,
        campaign,
        fire,
        hearth,
        lock,
        build,
        shield
    }
}

const copyNegozi = {
    "Offerta luce": {
        title: "Energia dal sole, ovunque",
        description: "Il solare virtuale permette al cliente di accedere ai benefici dell'energia fotovoltaica senza installare pannelli solari nella sua casa. Può ridurre i costi in bolletta, aumentare l'autonomia della sua casa e contribuire a un futuro più sostenibile."
    },
    "Elettrodomestici": {
        title: "Tecnologia che migliora la vita quotidiana",
        description: "I nuovi elettrodomestici combinano innovazione, efficienza energetica e design per offrire comfort quotidiano, risparmio intelligente e un'esperienza d'uso semplice e intuitiva."
    },
    "Riscaldamento": {
        title: "Il clima di casa? Finalmente perfetto",
        description: "Passare al riscaldamento elettrico significa dire addio agli sprechi e accogliere comfort, efficienza e risparmio. Un investimento che migliora la tua casa e valorizza ogni stagione dell’anno."
    },
    "Clima": {
        title: "Il clima di casa? Finalmente perfetto",
        description: "Passare al riscaldamento elettrico significa dire addio agli sprechi e accogliere comfort, efficienza e risparmio. Un investimento che migliora la tua casa e valorizza ogni stagione dell’anno."
    },
    "Fotovoltaico": {
        title: "Energia dal sole, libertà per te",
        description: "I pannelli fotovoltaici trasformano la luce del sole in energia pulita e conveniente. Mostra al cliente come ridurre i costi in bolletta, aumentando l'autonomia della sua casa contribuendo a un futuro più sostenibile."
    },
    "Fotovoltaico con Batteria": {
        title: "Energia dal sole, libertà per te",
        description: "I pannelli fotovoltaici trasformano la luce del sole in energia pulita e conveniente. Mostra al cliente come ridurre i costi in bolletta, aumentando l'autonomia della sua casa contribuendo a un futuro più sostenibile."
    },
    "Sintesi investimento": {
        title: "Un investimento su misura per te",
        description: "Con i prodotti giusti, il risparmio inizia subito. Riduci i costi in bolletta, ottimizza l'efficienza e ottieni un ritorno economico concreto nel tempo."
    },
    "Induzione": {
        title: "Più comfort, meno pensieri in cucina",
        description: "Cucinare a induzione significa vivere un’esperienza più fluida e piacevole: l’acqua bolle più velocemente, il calore si regola con precisione e l’ambiente resta più fresco e silenzioso. Senza fiamme né ingombri, lo spazio è più ordinato, moderno e semplice da gestire, migliorando la qualità del tempo passato in cucina."
    }
}
const copyOnline = {
    "Offerta luce": {
        title: "Energia dal sole, ovunque",
        description: "Il solare virtuale ti permette di accedere ai benefici dell'energia fotovoltaica senza installare pannelli solari nella tua casa. Riduci i costi in bolletta, aumenta l'autonomia della tua casa e contribuisci a un futuro più sostenibile."
    },
    "Elettrodomestici": {
        title: "Tecnologia che migliora la vita quotidiana",
        description: "I nuovi elettrodomestici combinano innovazione, efficienza energetica e design per offrire comfort quotidiano, risparmio intelligente e un'esperienza d'uso semplice e intuitiva."
    },
    "Riscaldamento": {
        title: "Il clima di casa? Finalmente perfetto",
        description: "Passare al riscaldamento elettrico significa dire addio agli sprechi e accogliere comfort, efficienza e risparmio. Un investimento che migliora la tua casa e valorizza ogni stagione dell’anno."
    },
    "Clima": {
        title: "Il clima di casa? Finalmente perfetto",
        description: "Passare al riscaldamento elettrico significa dire addio agli sprechi e accogliere comfort, efficienza e risparmio. Un investimento che migliora la tua casa e valorizza ogni stagione dell’anno."
    },
    "Fotovoltaico": {
        title: "Energia dal sole, libertà per te",
        description: "Con i pannelli fotovoltaici trasformano la luce del sole in energia pulita e conveniente. Riduci i costi in bolletta, aumenta l'autonomia della tua casa e contribuisce a un futuro più sostenibile."
    },
    "Fotovoltaico con Batteria": {
        title: "Energia dal sole, libertà per te",
        description: "Con i pannelli fotovoltaici trasformano la luce del sole in energia pulita e conveniente. Riduci i costi in bolletta, aumenta l'autonomia della tua casa e contribuisce a un futuro più sostenibile."
    },
    "Sintesi investimento": {
        title: "Un investimento su misura per te",
        description: "Con i prodotti giusti, il risparmio inizia subito. Riduci i costi in bolletta, ottimizza l'efficienza e ottieni un ritorno economico concreto nel tempo."
    },
     "Induzione": {
        title: "Più comfort, meno pensieri in cucina",
        description: "Cucinare a induzione significa vivere un’esperienza più fluida e piacevole: l’acqua bolle più velocemente, il calore si regola con precisione e l’ambiente resta più fresco e silenzioso. Senza fiamme né ingombri, lo spazio è più ordinato, moderno e semplice da gestire, migliorando la qualità del tempo passato in cucina."
    }
}

function GreenBox({ title, description, icon, extraClass, first }) {
    return (
        <div className={"col-12 col-md-6 d-flex flex-fill " + (extraClass ?? "")}>
            <div className={"d-flex flex-column green-box elevation-shadow " + (first ? "me-2" : "ms-2")}>
                <div className="green-box-title f18 d-flex align-items-center">
                    <div className="green-icon">
                        <img src={icon} alt="" role="presentation" />
                    </div>
                    <span className="bold lh100">{title}</span></div>
                <div className="d-flex green-box-content">

                    <div className="f14">{description}</div>
                </div>
            </div>
        </div>)
}

function BlueBox({ title, subtitle, body }) {
    return (
        <div className={"benefici-blue-box d-flex flex-column mt-3 elevation-shadow"}>
            <div className="benefici-blue-box-title d-flex align-items-center" >
                <div className="blue-icon">
                    <img src={cash} alt="" role="presentation" />
                </div>
                <div>
                    <div className='f18 bold'>
                        {title}</div>
                    <div className="f14" dangerouslySetInnerHTML={{ __html: subtitle }}></div>
                </div>
            </div>
            <div className="d-flex blue-box-content" dangerouslySetInnerHTML={{ __html: body }}>
            </div>
        </div>)
}
function sumArray(arr) {
    return arr.reduce((total, value) => total + value, 0);
}

const onlyIntegerEuroFormat = (number) => {
    if (Number.isNaN(number)) return number;
    return (Number.parseFloat(number)?.toFixed(0)?.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + " €").replace("-", "");
}

const onlyFloatEuroFormat = (number) => {
    if (Number.isNaN(number)) return number;
    const decimalPart = (number % 1).toFixed(2).substring(2);
    return (Number.parseFloat(number)?.toFixed(0)?.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + "," + decimalPart + "€").replace("-", "");
}

const ElettrodomesticiBox = ({ data }) => {
    const elettrodomestici = data.products.filter(item => item.name === "Televisore" || item.name === "TV" || item.name === "Asciugatrice" || item.name === "Frigo" || item.name === "Lavatrice" || item.name === "Induzione")
    const costo = onlyFloatEuroFormat(sumArray(elettrodomestici.map(x => parseFloat(x.scontato.replaceAll(".", "")))))
    const n = data["negozi"] === true
    console.log(data.products)
    const elettroHTML = elettrodomestici
        .filter(item => item.anni !== undefined && item.anni !== null)
        .map((item, index) => (
            `<div class="blue-box-row">
            <div class="title f14 lh30">${item.modello}</div>
            <div class="bb f20 lh30">${item.anni > 10 ? "+10" : item.anni} anni</div>
        </div>`
        ))
    return (<>
        <div className="d-flex flex-wrap flex-lg-nowrap">

            <GreenBox
                first={true}
                extraClass=" mt-lg-0"
                title="Miglior benessere domestico"
                description={"I nuovi elettrodomestici trasformano la tua casa in uno spazio più efficiente, accogliente e su misura per il tuo benessere quotidiano."}
                icon={images.Green["hearth"]} />
            <GreenBox
                extraClass="mt-3 mt-lg-0"
                title="Minore inquinamento acustico"
                description={n ? "Gli impianti moderni sono molto più silenziosi rispetto a quelli tradizionali, quindi la casa risulterà più silenziosa aumentando la sua serenità." : "Gli impianti moderni sono molto più silenziosi rispetto a quelli tradizionali, quindi la casa risulterà più silenziosa aumentando la tua serenità."}
                icon={images.Green["campaign"]} />
        </div>
        <BlueBox
            title="Stima dell'impegno economico per gli elettrodomestici"
            subtitle="Impegno economico necessario per <b>implementare le soluzioni scelte.</b>"
            body={`
                             <div class="blue-box-row">
                                <div class="title f14 lh30">Investimento per gli elettrodomestici  </div>
                                <div class="bb f20 lh30">${costo} </div>
                            </div>
                             <div class="blue-box-row">
                                <div class="title f14 lh30"> 
                                    <b>Stima del tempo di recupero dell’investimento </b>
                                </div>
                                <div class="bb f20 lh30"></div>
                            </div>
                           ${elettroHTML.join("")}
                        `}
        />
    </>
    )
}

const RiscaldamentoBox = ({ data }) => {
    const n = data["negozi"]
    let anni = data.products.filter(x => x.name === "Clima").map(x => x.anni)[0]
    try {
        if (data.producs.filter(x => x.name !== "Clima").length === 0)
            anni = data["RecuperoTotale"]
    }
    catch (e) {
        console.log("Error", e)
    }

    if (anni > 10)
        anni = "+10"

    const costo = onlyFloatEuroFormat(sumArray(data.products.filter(x => x.name === "Clima").map(x => parseFloat(x.scontato.replace(".", "")))))
    return (<>
        <div className="d-flex flex-wrap flex-lg-nowrap">
            <GreenBox
                extraClass=" mt-3 mt-lg-0"
                first={true}
                title="Miglior comfort abitativo"
                description={n ? "Le nuove soluzioni potrebbero migliorare il benessere in casa, garantendo una temperatura più stabile in estate e inverno con minori sprechi." : "Grazie alle energie rinnovabili, dipenderai meno dalle fluttuazioni di prezzo dell’energia, aumentando l’autonomia della tua casa."}
                icon={images.Green["fire"]} />
            <GreenBox
                extraClass="mt-3 mt-lg-0"
                title="Classe energetica superiore"
                description={"Il miglioramento dell’efficienza energetica può portare a una certificazione energetica più alta, rendendo l’immobile più sostenibile."}
                icon={images.Green["bolt"]} />
        </div>
        <BlueBox
            title="Stima dell'impegno economico per il riscaldamento"
            subtitle="Impegno economico necessario per <b>implementare le soluzioni scelte.</b>"
            body={`
                        <div class="blue-box-row">
                            <div class="title f14 lh30">Investimento per il riscaldamento  </div>
                            <div class="bb f20 lh30">${costo} </div>
                        </div>
                          <div class="blue-box-row">
                            <div class="title f14 lh30">Stima del tempo di recupero dell’investimento </div>
                            <div class="bb f20 lh30">${anni} anni </div>
                        </div>
                        `} />
    </>
    )
}

const FotoVBox = ({ data }) => {
    const n = data["negozi"] === true
    return (<>
        <div className="d-flex flex-wrap flex-lg-nowrap">
            <GreenBox
                first={true}
                extraClass=" mt-3 mt-lg-0"
                title="Energia solare senza il pannello"
                description={n ? "Il cliente può beneficiare di energia da fonti rinnovabili solari certificate con uno sconto pari al 100% dell’energia in determinate fasce orarie." : "Puoi beneficiare di energia da fonti rinnovabili solari certificate con uno sconto pari al 100% dell’energia in determinate fasce orarie."}
                icon={images.Green["bolt"]} />
            <GreenBox
                extraClass="mt-3 mt-lg-0"
                title="Prezzi bloccati"
                description={"Con il solare virtuale non ci saranno sorprese, grazie al canone mensile e al prezzo della componente energia bloccati per 3 anni."}
                icon={images.Green["lock"]} />
        </div>
        <BlueBox
            title="Stima dell'impegno economico per il riscaldamento"
            subtitle="Impegno economico necessario per <b>implementare le soluzioni scelte.</b>"
            body={`
                        <div class="blue-box-row">
                            <div class="title f14 lh30">Costo iniziale investimento </div>
                            <div class="bb f20 lh30">99,00 € </div>
                        </div>
                          <div class="blue-box-row">
                            <div class="title f14 lh30">Investimento per il solare virtuale </div>
                            <div class="bb f20 lh30">264,00€/anno</div>
                        </div>
                          <div class="blue-box-row">
                            <div class="title f14 lh30">Stima del risparmio annuale </div>
                            <div class="bb f20 lh30">+31%***</div>
                        </div>
                        `} />
    </>
    )
}

const FotoBox = ({ data }) => {
    console.log("FOTO ENTRA", data)
    const prodotti = data.products.filter(item => item.name === "Fotovoltaico" || item.name.includes("Batteria") || item.modello.includes("Plug"))
    const costo = prodotti[0].scontato
    const anni = prodotti[0].anni > 10 ? "+10" : prodotti[0].anni
    const n = data["negozi"] === true
    return (<>
        <div className="d-flex flex-wrap flex-lg-nowrap gx-4" >
            <GreenBox
                first={true}
                extraClass=" mt-3 mt-lg-0"
                title="Più indipendenza dalla rete"
                description={n ? "Grazie alle energie rinnovabili, il cliente dipenderà meno dalle fluttuazioni di prezzo dell’energia, aumentando l’autonomia della sua casa" : "Grazie alle energie rinnovabili, dipenderai meno dalle fluttuazioni di prezzo dell’energia, aumentando l’autonomia della tua casa."}
                icon={images.Green["plug"]} />
            <GreenBox
                extraClass="mt-3 mt-lg-0"
                title="Classe energetica superiore"
                description={"Il miglioramento dell’efficienza energetica può portare a una certificazione energetica più alta, rendendo l’immobile più sostenibile."}
                icon={images.Green["bolt"]} />
        </div>
        <BlueBox
            title="Stima dell'impegno economico per il fotovoltaico"
            subtitle="Impegno economico necessario per <b>implementare le soluzioni scelte.</b>"
            body={`
                <div class="blue-box-row">
                    <div class="title f14 lh30">Investimento per il fotovoltaico  </div>
                    <div class="bb f20 lh30">${costo},00 € </div>
                </div>
                    <div class="blue-box-row">
                    <div class="title f14 lh30">Stima del tempo di recupero dell’investimento </div>
                    <div class="bb f20 lh30">${anni} anni </div>
                </div>
            `} />
    </>
    )
}

const CotturaBox = ({ data }) => {
    const prodotti = data.products.filter(item => item.name === "Induzione")
    const costo = prodotti[0].scontato
    const anni = prodotti[0].anni > 10 ? "+10" : prodotti[0].anni
    const n = data["negozi"] === true
    return (<>
        <div className="d-flex flex-wrap flex-lg-nowrap gx-4" >
            <GreenBox
                first={true}
                extraClass=" mt-3 mt-lg-0"
                title="Maggiore sicurezza in cucina"
                description={n ? "Con l’induzione cucini senza fiamma, senza rischio di fughe di gas e con un piano che resta freddo al tatto: una soluzione più sicura per tutta la famiglia, anche con bambini in casa." : "Con l’induzione cucini senza fiamma, senza rischio di fughe di gas e con un piano che resta freddo al tatto: una soluzione più sicura per tutta la famiglia, anche con bambini in casa."}
                icon={images.Green["shield"]} />
            <GreenBox
                extraClass="mt-3 mt-lg-0"
                title="Pulizia e facilità di manutenzione"
                description={"La superficie liscia del piano a induzione si pulisce in un attimo: niente incrostazioni, griglie o bruciatori da smontare, solo un panno umido per farlo tornare come nuovo."}
                icon={images.Green["build"]} />
        </div>
        <BlueBox
            title="Stima dell'impegno economico per la cottura cibi"
            subtitle="Impegno economico necessario per <b>implementare le soluzioni scelte.</b>"
            body={`
                <div class="blue-box-row">
                    <div class="title f14 lh30">Investimento per la cottura cibi  </div>
                    <div class="bb f20 lh30">${costo},00 € </div>
                </div>
                    <div class="blue-box-row">
                    <div class="title f14 lh30">Stima del tempo di recupero dell’investimento </div>
                    <div class="bb f20 lh30">${anni} anni </div>
                </div>
            `} />
    </>
    )
}

function BeneficiComponent({ type }) {

    const foto = type.includes("Fotovoltaico") || (type.includes("Fotovoltaico") || type.includes("Plug"))

    const data = useSelector(get)
    const n = data["negozi"] === true
    const copy = n ? copyNegozi : copyOnline
    if (foto) type = "Fotovoltaico"
    else  if (copy[type] === undefined ) return <></>
    return (<>
        <BeneficiTitleComponent
            title={n ? "Il suo investimento, il suo futuro" : "Il tuo investimento, il tuo futuro"}
            description={n ? "Ogni scelta fatta oggi si traduce in un risparmio concreto e in un futuro più sostenibile. Fai scoprire al cliente come i prodotti che ha scelto migliorano la sua vita quotidiana e offrono un ritorno economico che cresce nel tempo." : "Ogni scelta che fai oggi si traduce in un risparmio concreto e in un futuro più sostenibile. Scopri come i prodotti che hai scelto migliorano la tua vita quotidiana e offrono un ritorno economico che cresce nel tempo."} />

        <div className="benefici-box row mb-3">
            <div className="d-flex flex-column col-12 col-lg-4 justify-content-center">
                <img className="benefici-left" src={images[type]} alt="" role="presentation" />
                <h4 className="f24 bold">{copy[type].title}</h4>
                <p className="f14 gen-subtitle mb-0">{copy[type].description}</p>
            </div>
            <div className="col-12 col-lg-8">
                {(type.includes("Fotovoltaico") && <FotoBox data={data} />)}
                {(type === "Riscaldamento" || type === "Clima") && <RiscaldamentoBox data={data} />}
                {(type === "Elettrodomestici") && <ElettrodomesticiBox data={data} />}
                {(type === "Offerta luce") && <FotoVBox data={data} />}
                {(type === "Induzione") && <CotturaBox data={data} />}
                {(type === "Sintesi investimento") &&
                    <BlueBox
                        title={n ? "Stima dell'impegno economico per il suo investimento" : "Stima dell'impegno economico per il tuo investimento"}
                        subtitle="Impegno economico necessario per <b>implementare le soluzioni scelte.</b>"
                        body={`
                        <div class="blue-box-row">
                            <div class="title f14 lh30">Investimento totale  </div>
                            <div class="bb f20 lh30">${data["Investimento"]} </div>
                        </div>
                            <div class="blue-box-row">
                            <div class="title f14 lh30">Stima del tempo di recupero dell’investimento dei prodotti scelti </div>
                            <div class="bb f20 lh30">${data["RecuperoTotale"]} anni </div>
                        </div>
                        <hr />
                        ${n ? `<div class="gen-subtitle f14">
                                Spiega al cliente che l’importo dell’investimento rappresenta <b>il 
                                totale dei costi che dovrà sostenere per le nuove soluzioni</b>
                                che ha scelto per la sua casa. 
                                Investire in tali nuove soluzioni può permettergli di risparmiare sulle spese energetiche. 
                                Abbiamo quindi indicato anche una stima (a parità di consumi) del tempo necessario per <b>recuperare l’investimento iniziale</b>, ossia quando i risparmi raggiungeranno i costi sostenuti.
                               </div>` :
                                `<div class="gen-subtitle f14">
                                L’importo dell’investimento rappresenta il <b>totale dei costi che dovrai sostenere per le nuove soluzioni</b>
                                che hai scelto per la tua casa.<br/>Investire in tali nuove soluzioni può permetterti di risparmiare sulle spese 
                                energetiche. Ti abbiamo quindi indicato anche una stima (a parità di consumi) del tempo necessario per 
                                <b>recuperare l’investimento iniziale</b>, ossia quando i risparmi raggiungeranno i costi sostenuti.
                                </div>`
                            }
                        `}
                    />
                }
            </div>
        </div>


        {data["extraco2"] && data["extraco2"].length > 1 && (
                <p
                className="small-note my-3 f12"
                dangerouslySetInnerHTML={{ __html: data["extraco2"] }}
                ></p>
        )}
        {(type === "Elettrodomestici") &&
            <BlueBoxComponent icon="info">
                <div className="blue f14">
                    {n ? "Specifica al cliente che per i prodotti Samsung il finanziamento è l'unica modalità di acquisto disponibile." : "Per i prodotti Samsung il finanziamento è l'unica modalità di acquisto disponibile."}</div>
                <div className="f14"> {n ? "Per gli altri prodotti non Samsung è possibile scegliere fra il pagamento in un’unica soluzione e la modalità di finanziamento." : "Per gli altri prodotti non Samsung è possibile scegliere fra il pagamento in un’unica soluzione e la modalità di finanziamento."}</div>
            </BlueBoxComponent>
        }

        {(type === "Sintesi investimento") &&
            <BeneficiFinaliComponent />
        }

        {(type === "Offerta luce") && <div className="f12">
            <b>* Il prezzo si riferisce alla sola componente energia (IVA e imposte escluse) ed è bloccato per i primi 36 mesi.</b> Tale prezzo è comprensivo delle perdite di rete che sono applicate come definite, pubblicate e aggiornate da ARERA. L’extra-consumo nelle ore solari (10-17) avrà il prezzo a consumo della componente energia delle ore non solari (17-10). <br /> <br />
            <b>** La produzione indicata è una produzione media annua nazionale, tiene in considerazione le oscillazioni giornaliere e geografiche del meteo.</b> Fonte: Stima di produzione PVGIS (Roma, Esposizione SUD, Perdite di sistema 14%, Inclinazione 25 gradi). <br /> <br />
            <b>*** La stima è calcolata su un consumo medio giornaliero di 3kWh, distribuito nella fascia oraria 10-17.  </b></div>}

    </>)

}

export default BeneficiComponent;